import { cropConnectApiClient } from '../services/cropConnectApiClient';

export const handleDocumentPreview = async (id: string) => {
  try {
    const response = await cropConnectApiClient.downloadDocument(id);
    if (response && response.data) {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    } else {
      console.error('Failed to fetch document data');
    }
  } catch (error) {
    console.error('Error opening document:', error);
  }
};

export const handleGeneralDocumentPreview = async (
  widgetId: string,
  documentId: string
) => {
  try {
    const file = await cropConnectApiClient.downloadGeneralDocument(
      widgetId,
      documentId
    );
    console.log(file);
    if (file) {
      const blob = new Blob([file.data], {
        type: file.headers['content-type'],
      });
      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    } else {
      console.error('Failed to fetch document data');
    }
  } catch (error) {
    console.error('Error opening document:', error);
  }
};

export const handleGeneralDocumentInMyTaskPreview = async (id: number) => {
  try {
    const response = await cropConnectApiClient.downloadGeneralDocumentForTask(
      id,
      '123'
    );
    if (response && response.data) {
      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      });
      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    } else {
      console.error('Failed to fetch document data');
    }
  } catch (error) {
    console.error('Error opening document:', error);
  }
};
